type CardProps = {
  title: string;
  description: string;
  image: string;
};

const Card = ({ title, description, image }: CardProps) => {
  return (
    <>
      <style>
        {`
          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-5px); }
          }
        `}
      </style>

      <div className="group p-[2px] rounded-3xl bg-[linear-gradient(170.94deg,#745EF0_0%,rgba(116,94,240,0.1)_50%,#745EF0_100%)] transition-transform duration-300 ease-in hover:scale-[1.03]">

        <div className="p-3 md:5 rounded-3xl backdrop-blur-md bg-[#0E0924]">

          {/* MOBILE VIEW */}
          <div className="flex flex-col md:hidden">

            {/* IMAGE + HEADING IN SAME LINE */}
            <div className="flex items-center gap-2">

              <img
                src={image}
                alt={title}
                className="w-12 h-10 object-contain shrink-0 group-hover:[animation:float_3s_cubic-bezier(0.4,0,0.1,1)_infinite]"
              />

              <h2 className="text-white text-xl font-semibold leading-tight font-rajdhani">
                {title}
              </h2>

            </div>

            {/* DESCRIPTION */}
            <p className="text-gray-300 mt-3 md:mt-0 text-sm leading-relaxed font-gilroy-medium">
              {description}
            </p>

          </div>

          {/* TABLET + DESKTOP VIEW */}
          <div className="hidden md:flex items-center gap-4">

            {/* ICON */}
            <img
              src={image}
              alt={title}
              className="w-14 h-14 object-contain shrink-0 group-hover:[animation:float_3s_cubic-bezier(0.4,0,0.1,1)_infinite]"
            />

            {/* TEXT */}
            <div className="flex flex-col gap-1">

              <h2 className="text-white text-2xl font-semibold leading-tight font-rajdhani">
                {title}
              </h2>

              <p className="text-gray-300 text-md leading-relaxed font-gilroy-medium">
                {description}
              </p>

            </div>

          </div>

        </div>
      </div>
    </>
  );
};

export default Card;